<template>
  <div class="chapterList">
    <ul class="bg-white">
      <li v-for="(item, index) in dataList" :key="index" :id="item.gid">
        <div
          @click="onOff(index)"
          class="padding0-15 row cen-between chapterTit ft14 gray-2"
        >
          <!-- <span class="flagBox text-center ilbk ft10 lineHe10">直播</span> -->
          <span>
            <span class="flagBox text-center ilbk ft10 lineHe10 flagOrgBox">{{
              item.isLive
            }}</span>
            <span class="margin5-left">{{ item.gname }}</span>
          </span>
          <span class="bracket margin10-left">
            <!-- <img v-if="!item.onOff" src="../../assets/imgs/down.png" alt="" /> -->
            <van-icon name="arrow-down" v-if="!item.onOff" />
            <!-- <img v-else src="../../assets/imgs/top.png" alt="" /> -->
            <van-icon v-else name="arrow-up" />
          </span>
        </div>
        <ol class="padding0-15" v-if="item.onOff">
          <li
            @click="selectPlay(index, idx, item, itm)"
            class="ft14 padding0-10"
            v-for="(itm, idx) in item.list"
            :key="idx"
          >
            <div class="row cen-between">
              <section class="row padding15-0">
                <span class="gray-8 lineHe14 padding6_top" v-if="idx < 10"
                  >0{{ 1 + idx }}</span
                >
                <span class="gray-8 lineHe14 padding6_top" v-else>{{
                  1 + idx
                }}</span>
                <span class="padding15-left">
                  <p
                    class="gray-2 padding10-bottom"
                    :class="{
                      orange: outlineIndex == index && catalogIdx == idx,
                    }"
                  >
                    {{ itm.videoName }}
                  </p>
                  <!-- <p class="gray-2 lineHe14 padding10-bottom" :class="{'blue':index == idx}">{{itm.alivideocover}}</p> -->
                  <p class="gray-8 ft12 lineHe12">
                    <!-- <span class="playback ilbk ft10 lineHe10 text-center">回放</span> -->
                    <span>{{ itm.timelength }}</span>
                  </p>
                </span>
              </section>
              <span
                class="imgPlay"
                v-if="outlineIndex == index && catalogIdx == idx"
              >
                <img src="../../assets/imgs/playing.png" alt="" />
              </span>
              <van-icon name="checked" v-else v-show="itm.watchType" color="#B0B3B8" />
            </div>
            <div class="lineE0"></div>
          </li>
        </ol>
      </li>
    </ul>
  </div>
</template>

<script>
import {getVideoListByGid} from "@/model/player/player"
export default {
  name: "chapterList",
  data() {
    return {
      dataList: [],
      outlineIndex: "9999",
      catalogIdx: "9999",
    };
  },
  props: {
    catalogueData: {
      type: Array,
      default() {
        return [];
      },
    },
    isJump: {
      // 是否需要跳转
      type: Boolean,
      default() {
        return false;
      },
    },
    outline: {
      type: String,
      default() {
        return "9999";
      },
    },
    catalog: {
      type: String,
      default() {
        return "9999";
      },
    },
    gid:{
      type:Number,
      default:0
    },
    time:{
      type:Number,
      default:0
    }
  },
  watch: {
    catalogueData(val) {
      console.log(val)
      this.dataList = val;
    },
    outline(val) {
      this.outlineIndex = val;
    },
    catalog(val) {
      this.catalogIdx = val;
    },
  },
  mounted() {
    this.outlineIndex = this.outline;
    this.catalogIdx = this.catalog;
  },
  methods: {
    selectPlay(index, idx, item, itm) {
      if (this.isJump) {
        this.$router.push({
          path: "/curriculum",
          query: {
            cid: this.$route.query.cid,
            outline: index.toString(),
            catalog: idx.toString(),
            gid: item.gid,
            vid: itm.vid,
          },
        });
      } else {
        this.$emit("replaceVideo",this.dataList[this.outlineIndex].list[this.catalogIdx])
        //  console.log(this.time)
        //   console.log(this.dataList[this.outlineIndex].list[this.catalogIdx].totalTime)
        // if(this.time > (this.dataList[this.outlineIndex].list[this.catalogIdx].totalTime - 10)) {
        //   this.dataList[this.outlineIndex].list[this.catalogIdx].watchType = true
        // }
        if (this.$route.path == "/curriculum") {
          if (this.outline && this.catalog) {
            (this.outlineIndex = index.toString()),
              (this.catalogIdx = idx.toString());
          }
        }
      }
      this.$emit("chapterEmit", {
        index,
        idx,
        item,
        itm,
        type:'1'
      });
    },
    onOff(index) {
      if(this.dataList[index].list.length == 0) {
        let data = {
          uid : !this.uid() ? null : this.uid(),
          gid : this.dataList[index].gid,
          cid : this.$route.query.cid
        }
        getVideoListByGid(data).then(res => {
          res.data.forEach(item => {
            let hour = item.timelength.substring(0, 2);
            let minute = item.timelength.substring(3, 5);
            let second = item.timelength.substring(6, 8) * 1;
            item.totalTime = hour * 60 * 60 + minute * 60 + second;
            if (item.totalTime < item.maxprogress + 5 ) {
              item.watchType = true;
            } else {
              item.watchType = false;
            }
          })
          this.dataList[index].list = res.data
        })
      }
      this.dataList[index].onOff = !this.dataList[index].onOff;
    },
  },
  created(){
    this.$nextTick(() => {
      if(this.gid != 0) {
        // for (const key in this.dataList) {
        //   if(this.dataList[key].gid == this.gid) {
        //     this.outlineIndex = key
        //     break
        //   }
        // }
        document.getElementById(this.gid).scrollIntoView();
      }
    })
  }
};
</script>
<style scoped lang="less">
.padding6_top {
  padding-top: 0.3rem;
}
.bracket {
  display: inline-block;
  width: 14/20rem;
  height: 8/20rem;
  margin-top: -2rem;
  img {
    width: 100%;
  }
}
.brackeDown {
  transform: rotate(270deg);
  // transform-origin: center;
  display: inline-block;
  width: 24/60rem;
  height: 36/60rem;
  img {
    width: 100%;
  }
}
.chapterTit {
  height: 48/20rem;
  line-height: 48/20rem;
  background: rgba(244, 244, 244, 1);
  .flagBox {
    width: 33/20rem;
    height: 16/20rem;
    line-height: 16/20rem;
    border: 1px solid rgba(23, 116, 233, 1);
    color: #1774e9;
    border-radius: 12/20rem;
  }
  .flagOrgBox {
    color: #f08344;
    border: 1px solid rgba(240, 131, 68, 1);
  }
}
.playback {
  width: 33/20rem;
  height: 16/20rem;
  line-height: 16/20rem;
  color: #f08344;
  background: rgba(255, 240, 232, 1);
  border-radius: 8/20rem;
  margin-right: 0.4rem;
}
.imgPlay {
  width: 0.6rem;
  height: 0.75rem;
  img {
    width: 100%;
  }
}
</style>
